module.exports = __webpack_public_path__ + "img/piano-3.dde0da02.png";